import { gql } from "@apollo/client";
export const AUTHENTICATION = gql`
mutation Authentication($where: AuthenticationInput!) {
  authentication(where: $where) {
    accessToken
    data {
      id_user
      first_name
      last_name
      phone_number
    }
  }
}
`;